import { createClient } from "@connectrpc/connect";
import { BaseLoginResponse } from "../../../../base/response/BaseLoginResponse";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { LoginService } from "../../../../generated/grpc/login_pb";
import { grpcFincaLoteDatabase } from "../../../terceros/database/GrpcFincaLoteDatabase";
import { mapGrpcLoginResponse } from "./mapGrpcLoginResponse";
import { secureStorage } from "./SecureStorageService";

/** Login con el token del portal de Nitria (`LoginService.LoginPortal`, gRPC-Web; SSO de Nitrofert,
 *  decidido 2026-09-30). Devuelve lo mismo que el login con contraseña. Guarda la sesión cifrada,
 *  reemplazando la que hubiera, y descarta el token que el transporte tenía en memoria para que las
 *  llamadas siguientes usen la sesión nueva. */
export class LoginPortalGrpcService<TResponse extends BaseLoginResponse> {
  /** Inicia sesión con el token del portal. Cada rechazo del servidor llega como `ValidationError` con el
   *  motivo exacto; una falla de red, como `Error` genérico. */
  async loginAsync(token: string): Promise<TResponse> {
    const client = createClient(LoginService, grpcTransportProvider.get());

    let grpcResponse;
    try {
      grpcResponse = await client.loginPortal({ token });
    } catch (error) {
      throw mapConnectError(error);
    }

    // Best-effort: si falla, no debe tirar abajo un login que por lo demás salió bien.
    grpcFincaLoteDatabase
      .replaceAllAsync(grpcResponse.fincas)
      .catch((error: unknown) =>
        console.error("No se pudo guardar fincas/lotes de gRPC login:", error),
      );

    const response = mapGrpcLoginResponse<TResponse>(grpcResponse);
    await secureStorage.set(response.token);
    grpcTransportProvider.clearToken();
    return response;
  }
}
